import React from "react";
import { IIcons } from "./icons";

const Documents = ({ fillColor }: IIcons.IconProps) => (
  <svg
    width="40"
    height="51"
    viewBox="0 0 40 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={fillColor}
  >
    <path
      d="M4.6832 0.602539C2.52845 0.602539 0.783203 2.32369 0.783203 4.44869V46.7564C0.783203 48.8814 2.52845 50.6025 4.6832 50.6025H35.8832C38.038 50.6025 39.7832 48.8814 39.7832 46.7564V4.44869C39.7832 2.32369 38.038 0.602539 35.8832 0.602539H4.6832ZM20.2832 6.37177C27.8219 6.37177 33.9332 12.3987 33.9332 19.8333C33.9332 27.2679 27.8219 33.2948 20.2832 33.2948C12.7445 33.2948 6.6332 27.2679 6.6332 19.8333C6.6332 12.3987 12.7445 6.37177 20.2832 6.37177ZM17.6248 10.2179C17.6248 10.2179 10.5332 12.841 10.5332 19.8333C10.5332 28.5737 20.2832 29.4487 20.2832 29.4487L17.5943 26.8608L17.6248 23.3302L14.9664 20.7085H12.3042V18.9619L16.7374 16.3365V14.5899H18.5084L19.3958 15.4651L21.1668 14.5899V10.2179H19.3958V12.8396H17.6248V10.2179ZM26.3008 12.31L24.7164 12.8396V13.7148H23.829L22.9416 14.5899V16.3402L24.7164 15.4651L27.3748 16.3402L26.4874 18.0868L24.7164 17.2116H22.9416L21.1706 18.9619V20.7085L22.9416 22.455H24.7164L25.6038 24.2053L22.9416 29.4487C22.9416 29.4487 30.0351 26.8256 30.037 19.8333C30.037 15.4641 26.3008 12.31 26.3008 12.31ZM12.4832 39.0641H28.0832C29.1596 39.0641 30.0332 39.9256 30.0332 40.9872C30.0332 42.0487 29.1596 42.9102 28.0832 42.9102H12.4832C11.4068 42.9102 10.5332 42.0487 10.5332 40.9872C10.5332 39.9256 11.4068 39.0641 12.4832 39.0641Z"
      fill="#06224B"
    />
  </svg>
);
export default Documents;
